// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yz7d","col":"styles_col__UTkvI"};